export const DEFAULT_BREAKPOINTS = {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '1024px',
    xl: '1400px',
    xxl: '1536px',
} as const;
